var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiSampleReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6744_129535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8325 92.5C78.6143 92.5 97.0825 74.0317 97.0825 51.25C97.0825 28.4683 78.6143 10 55.8325 10C33.0508 10 14.5825 28.4683 14.5825 51.25C14.5825 74.0317 33.0508 92.5 55.8325 92.5Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5251 72.56C72.1593 69.8793 75.6778 69.0655 77.3836 70.7422C79.0894 72.4189 78.3364 75.9507 75.7008 78.6321C74.6627 79.7176 73.3798 80.5388 71.9593 81.0268L60.6544 92.2444L55.5034 86.8272L67.1949 76.3438C67.6583 74.9145 68.4573 73.6171 69.5251 72.56Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3706 63.3004L45.2235 89.5953L64.1507 79.3501L70.9244 82.9451C70.9244 82.9451 55.4518 108.812 44.8577 105.868C34.2636 102.923 15.4513 76.223 18.8408 67.9825C22.2303 59.742 33.3706 63.3004 33.3706 63.3004Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7133 64.9873L34.8882 53.3304L27.6997 48.8493L19.8831 58.4108L34.7133 64.9873Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.7134 64.9873L35.1787 53.6208L27.6997 48.8493L30.2407 62.9158L34.7134 64.9873Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7364 56.958C41.7971 56.958 47.5208 51.2342 47.5208 44.1736C47.5208 37.113 41.7971 31.3892 34.7364 31.3892C27.6758 31.3892 21.952 37.113 21.952 44.1736C21.952 51.2342 27.6758 56.958 34.7364 56.958Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5274 55.9458L36.0509 62.917C36.0509 62.917 51.4458 108.521 51.4458 110.844C51.4458 113.168 55.8028 114.621 53.1886 117.235C50.5744 119.849 58.0544 122.063 54.0239 124.151C49.9934 126.239 24.8507 137.661 22.0549 136.631C14.3441 133.791 22.3817 123.352 22.3817 123.352C22.3817 123.352 16.5895 118.687 17.4609 116.363C18.3323 114.04 12.2324 69.5978 12.2324 69.5978L21.5274 55.9458Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9561 47.2362L35.6004 50.5249C35.6004 50.5249 37.2448 44.6053 39.8757 43.2898C42.5066 41.9743 42.8355 40.0011 42.8355 40.0011C42.8355 40.0011 46.1242 44.2764 48.4263 43.2898C50.7283 42.3032 51.7149 41.6455 49.084 37.699C46.4531 33.7526 47.1108 35.7258 47.1108 35.7258C47.1108 35.7258 44.8087 32.4372 45.1376 33.4238C45.4664 34.4104 43.1644 30.7928 43.1644 31.7794C43.1644 32.766 41.52 29.8062 41.52 30.7928C41.52 31.7794 34.6138 28.4908 35.6004 29.8062C36.587 31.1217 29.6808 27.1753 26.3921 32.4372C23.1035 37.6991 18.5433 36.726 20.1657 40.0079C21.788 43.2898 21.1302 52.1692 21.1302 52.1692H25.6658C25.6658 52.1692 30.3386 43.2898 33.9561 47.2362Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.208 117.068H70.5061C68.0114 117.068 65.9819 115.039 65.9819 112.543V58.8111C65.9819 56.316 68.0114 54.2865 70.5061 54.2865H108.208C110.703 54.2865 112.732 56.316 112.732 58.8111V112.543C112.732 115.039 110.703 117.068 108.208 117.068Z",
    fill: "#00BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5382 101.885H86.2503C85.6065 101.885 85.0828 101.481 85.0828 100.984V78.223C85.0828 77.7262 85.6065 77.322 86.2503 77.322H91.5382C92.1821 77.322 92.7058 77.7262 92.7058 78.223V100.984C92.7058 101.481 92.1821 101.885 91.5382 101.885Z",
    fill: "#FBFCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0559 88.4711C73.5358 88.4711 73.1125 88.7978 73.1125 89.1991V100.958C73.1125 101.359 73.5358 101.686 74.0559 101.686H79.3438C79.864 101.686 80.2872 101.359 80.2872 100.958V89.1991C80.2872 88.7978 79.864 88.4711 79.3438 88.4711H74.0559Z",
    fill: "#FBFCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.734 101.885H98.4456C97.8018 101.885 97.2781 101.48 97.2781 100.984V63.6825C97.2781 63.1856 97.8018 62.7815 98.4456 62.7815H103.734C104.377 62.7815 104.901 63.1856 104.901 63.6825V100.984C104.901 101.48 104.377 101.885 103.734 101.885Z",
    fill: "#FBFCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7817 96.1294C69.3861 95.0645 72.8573 96.0611 73.5346 98.3551C74.2119 100.649 71.8391 103.371 68.2332 104.436C66.7987 104.881 65.2784 104.976 63.7996 104.713L48.4705 109.032L46.597 101.796L61.9077 98.3061C63.0066 97.2816 64.3351 96.5351 65.7817 96.1294Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6687 70.4822L36.2661 99.2249L57.7871 99.4563L61.9638 105.888C61.9638 105.888 35.8792 120.991 28.0467 113.274C20.2143 105.556 16.7292 73.0808 23.693 67.522C30.6567 61.9631 38.6687 70.4822 38.6687 70.4822Z",
    fill: "#3F3D56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6744_129535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiSampleReport);
export default __webpack_public_path__ + "static/media/mi-sample-report.ed13fe68e0d429007fa45727f5666500.svg";
export { ForwardRef as ReactComponent };